<template>
  <el-row>
    <el-card class="card-horizontal completed-card full-line">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="16">
          <el-row :gutter="20">
            <el-col :xs="24" :md="12" class="completed-full-line__title">
              <header class="card-horizontal__header">
                <h4 class="h4 font-family-body"><img :src="checkImage"/>{{ course.fullLine }}</h4>
              </header>
            </el-col>
            <el-col :xs="24" :md="12" class="completed-full-line__completion">
              <h4 class="h6 font-family-body">{{ $t('trainingModuleCompletedDateLabel') }}&nbsp;{{ usersCourse.completed }}</h4>
            </el-col>
          </el-row>
        </el-col>
        <el-col :xs="24" :sm="8" class="completed-full-line__action">
          <div class="card-horizontal__actions">
            <a v-if="course.fullLine.includes('Outboard')" :href="outboardCertLogo" download><span class="card-horizontal__link-emphasized">{{ $t('trainingModuleDownloadLogo') }}</span></a>
            <a v-if="course.fullLine.includes('MerCruiser')" :href="mercruiserCertLogo" download><span class="card-horizontal__link-emphasized">{{ $t('trainingModuleDownloadLogo') }}</span></a>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
  import api from '@/api';
  import router from '@/router';
  import checkImage from '@/assets/images/green-check.svg';
  import outboardCertLogo from '@/assets/images/outboard_certificate_logo.png';
  import mercruiserCertLogo from '@/assets/images/mercruiser_certificate_logo.png';

  export default {
    name : 'TrainingFullLineCertifiedCard',
    data() {
      return {
        checkImage,
        outboardCertLogo,
        mercruiserCertLogo,
      }
    },
    props : {
      course      : Object,
      usersCourse : Object,
    },
    methods : {
      downloadCertificate: function(url) {
        axios.get(url, { responseType: 'blob' })
          .then(({ data }) => {
            const blob    = new Blob([data], { type: 'image/png' })
            let link      = document.createElement('a')
            link.href     = window.URL.createObjectURL(blob)
            link.download = 'certificate.png'
            link.click()
          }).catch(error => console.error(error))
        }
    },
  };
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
  @import 'element-theme-chalk/src/mixins/mixins.scss';

  .module {
    &__link {
      overflow: hidden;
      display: block;
      position: relative;
      width: 100%;
      height: 100%;
      cursor: pointer;
      text-decoration: none;
    }
  }
  .completed-card.full-line{
    background-color: #f9f9f9;
    box-shadow: none;
    border: none;
    padding: 5px;
  }
  .completed-full-line__title{
    img{
      position: relative;
      top: 3px;
      width: 20px;
      margin-right: 10px;
    }
    h4{
      @include res(sm) {
        margin-bottom: 10px;
      }
      @include res(md) {
        margin-bottom: 0px;
      }
    }

  }
  .completed-full-line__completion{

    h6, .h6{
      font-size: 17px !important;
      font-weight: lighter;
      @include res(sm) {
        margin: 0 0 10px 0;
      }
      @include res(md) {
        margin: 2px 0 0 0;
      }
    }
    @include res(sm) {
      text-align: left;
    }
    @include res(md) {
      text-align: center;
    }
  }
  .completed-full-line__action{
    .card-horizontal__actions{
      @include res(xs) {
        text-align: left;
        padding: 20px 0 0 0;
      }
      @include res(sm) {
        padding: 0 20px 0 0;
        text-align: right;
      }

    }
  }

  .card-horizontal{
    &__link-locked::after {
      content: none;
    }
    .card-horizontal__actions a {
      text-decoration:none;
    }

    .card-horizontal__media {
      @include res(xs) {
        margin-bottom: 30px;
      }

      @include res(md) {
        margin-top: 10px;
      }

      img{
        object-position: bottom;
        object-fit: contain;
      }
    }
  }
</style>